export const ESTADO_CAJA = {
	ABIERTA: 1,
	CERRADA: 2,
	INACTIVA: 3,
}